
<div class="modal-dialog modal-dialog-centered" role="document">
  <div class="modal-content">
    <div class="modal-header border-0 pb-2">
      <p class="modal-title">
        <i class="fas fa-clock mr-2"></i>
        <span class="font-weight-bold">Session Timeout Warning</span>
      </p>
    </div>
    <div class="modal-body pt-2">
      <div class="px-3 py-2">
        <p class="text-muted mb-3 small">
          Your session will expire due to inactivity in:
        </p>
        <div class="text-center mb-4">
          <h3 class="timer-display font-weight-bold text-danger">
            {{ formattedTimeRemaining }}
          </h3>
        </div>
        <p class="text-muted small mb-4">
          You will be automatically logged out for your security. Click below to stay logged in.
        </p>
        <div class="d-flex justify-content-center">
          <button
            type="button"
            class="btn btn-sm btn-primary px-4"
            @click="extendSession"
          >
            <i class="fas fa-check mr-2"></i>
            Stay Logged In
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
